import XTNATrabajoChart from './Chart.jsx';

export default {
  XTNATrabajoChart,
};



// WEBPACK FOOTER //
// ./src/App/xtnaTrabajo/index.js